import qs from 'qs';
import axios from '@/modules/axios';

function publishAds(payload) {
	return axios.post('/publish', payload);
}

function loadPublishers(filter) {
	if (filter) {
		const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
		return axios.get(`/publishers${query}`);
	}
	return axios.get('/publishers');
}

export {
	publishAds,
	loadPublishers,
};



// WEBPACK FOOTER //
// ./src/modules/api/Publisher.js